import { ENVIRONMENTS, REMOTES } from '@innovyze/lib_get_remote';

type EnvironmentConfig = {
	fed_env: ENVIRONMENTS;
	build_env: ENVIRONMENTS;
};

declare global {
	interface Window {
		initializeRemote: (
			remoteKey: string,
			envOverride: Partial<EnvironmentConfig>,
		) => Promise<void>;
	}
}

const getEnvironment = async (
	envOverride: Partial<EnvironmentConfig>,
): Promise<EnvironmentConfig> => {
	if (envOverride.build_env || envOverride.fed_env) {
		return envOverride;
	}

	// Env vars for CloudOS are defined in .cloudos/service_config
	// They are then stored as /evnironment.json in S3
	const file = await fetch('/environment.json');
	return file.json();
};


const getRegion = (): string => {
	if (window.origin.includes('-eu')) {
		return 'eu';
	}

	if (window.origin.includes('-ap')) {
		return 'ap';
	}

	return '';
};

window.initializeRemote = async (
	remoteKey: string,
	envOverride: Partial<EnvironmentConfig>,
) => {
	try {
		const { getRemote, getFederatedEnv } =
			await import('@innovyze/lib_get_remote');

		const environment = await getEnvironment(envOverride);
		const federatedEnv = getFederatedEnv(environment);
		const region = getRegion();

		const remote = getRemote(remoteKey as REMOTES, federatedEnv, region);

		const [remoteReference] = Object.values(remote);
		const [key, url] = remoteReference.split('@');

		return new Promise((resolve, reject) => {
			const script = document.createElement('script');

			script.src = url + '?ts=' + Date.now();
			script.async = true;
			script.onload = () => {
				// @ts-expect-error unknown key type
				resolve(window[key]);
			};
			script.onerror = () => {
				reject(
					new Error(
						`Failed to load remote: ${remoteKey} from ${url}`,
					),
				);
			};
			document.head.appendChild(script);
		});
	} catch (err) {
		console.error(err);
	}
};

import('./index');
